import { z } from 'zod';

export const PrecisionSchema = z.coerce.number().int().min(0).max(10);
